import { useTranslation } from 'react-i18next'

import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { AppearanceSection } from './AppearanceSection'
import { BasicSettingsSection } from './BasicSettingsSection'

export const MultiAnchorSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multiAnchor',
  })

  return (
    <>
      <Paper
        data-cy='section-multi-anchor'
        sx={{ mt: 0 }}
      >
        <SectionHeader
          subtitle={t('description')}
          title={t('title')}
        />
      </Paper>

      <BasicSettingsSection />

      <AppearanceSection />
    </>
  )
}
